export { RCTModal } from './RCTModal';
export { default } from './Modal';
